<template>
  <div class="goods" id="goods" name="goods">
	<!-- 主要内容区 -->
	<div class="main">
	  <div class="list">
		<ArticleList :list="articleList" v-if="articleList.length>0"></ArticleList>
		<div v-else class="none-product">还没有文章</div>
	  </div>
	  <!-- 分页 -->
	  <div class="pagination" v-if="articleList.length > 0">
		<el-pagination
		  background
		  layout="prev, pager, next"
		  :page-size="pageSize"
		  :total="total"
		  @current-change="currentChange"
		></el-pagination>
	  </div>
	  <!-- 分页END -->
	</div>
	<!-- 主要内容区END -->
  </div>
</template>

<script>
	export default{
		data(){
			return{
				total: 0, // 商品总量
				pageSize: 20, // 每页显示的商品数量
				currentPage: 1, //当前页码
				articleList:[]
			}
		},
		created() {
			this.getData();
		},
		methods:{
			getData(){
				this.$axios.post("/api/article/getAllArticles", {
					keyword: "",
					page:this.currentPage
				}).then(res => {
					if (res.data.code == "200" || res.data.code == 200) {
						this.articleList = res.data.data.articleList
						this.total = res.data.data.total
					}
				}).catch(err => {
					return Promise.reject(err);
				});
			},
			// 页码变化调用currentChange方法
			currentChange(currentPage) {
				this.currentPage = currentPage;
				this.getData();
			},
		}
	}
</script>

<style scoped>
.goods {
  background-color: #f5f5f5;
}
/* 主要内容区CSS */
.goods .main {
  margin: 0 auto;
  max-width: 1225px;
}
.goods .main .list {
  min-height: 650px;
  padding-top: 14.5px;
  margin-left: -13.7px;
  overflow: auto;
}
.goods .main .pagination {
  height: 50px;
  text-align: center;
}
.goods .main .none-product {
  color: #333;
  margin-left: 13.7px;
}
/* 主要内容区CSS END */
</style>